'use client';
import React, {useCallback} from 'react';
import {
  WithdrawalSuccessModal,
  InterstitialsManager,
  Interstitials,
  AWSManager,
  I18n,
} from '@sdk-mobile';
import {useSearchParams, usePathname, useRouter} from 'next/navigation';
import Modal from '@/components/atoms/Modal';
import {removeSearchParams} from '@/utils/url-params';

const WithdrawSuccessParams = {
  withdrawSuccess: 'withdrawSuccess',
};

export default function WithdrawSuccess() {
  const searchParams = useSearchParams();
  const isWithdrawSuccess = searchParams?.get(WithdrawSuccessParams.withdrawSuccess);
  const pathname = usePathname();
  const router = useRouter();

  const handleDone = useCallback(() => {
    InterstitialsManager.sendTrigger(Interstitials.POST_WITHDRAWAL);
    if (!searchParams) return;

    // this is to preserve the query params except the withdrawSuccess ones
    router.replace(
      pathname +
        '?' +
        removeSearchParams(searchParams, Object.keys(WithdrawSuccessParams)).toString()
    );
  }, [pathname, router, searchParams]);

  if (isWithdrawSuccess) {
    AWSManager.trackEvent('WITHDRAWAL_SUCCESS_MODAL');
    return (
      <Modal>
        <WithdrawalSuccessModal
          title={I18n.message('Success!')}
          bodyText={I18n.message(
            'Your withdrawal request has been completed. You will receive an email confirming the transaction.'
          )}
          numberOfLines={4}
          onDone={handleDone}
        />
      </Modal>
    );
  }

  return null;
}
